import { object, string } from 'yup';

import { ProviderName } from 'v2/constants';
import { PartnerModel } from 'v2/types/PartnerModel';

export type PartnerForm = Omit<PartnerModel, 'id' | 'order'>;

export const initialValues: PartnerForm = {
  name: '',
  shortDescription: '',
  link: '',
  iconId: '',
  isActive: false,
  providerName: ProviderName.BELATRA,
};

export const validationSchema = object().shape({
  iconId: string().required(),
});
